/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Lower_Lofty_Mule_AskInputs */

const fr_lower_lofty_mule_ask = /** @type {(inputs: Lower_Lofty_Mule_AskInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Modifier ${i?.title} - Admin`)
};

/**

* @param {Lower_Lofty_Mule_AskInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const lower_lofty_mule_ask = /** @type {((inputs: Lower_Lofty_Mule_AskInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lower_Lofty_Mule_AskInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_lower_lofty_mule_ask(inputs)
});